import { Component, OnInit, ElementRef, ViewChild, ViewEncapsulation } from '@angular/core';
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ResigteringService } from '../auth/resigtering.service';
import Swal from 'sweetalert2';
import { IRegisterInterface } from '../../../interfaces/registerInterface';
import { LoginService } from '../auth/login.service';
import { UserService } from '../../../services/user';
import { Observable } from 'rxjs/internal/Observable';
import { map } from 'rxjs';
import { DeviceDetectorService } from '../../../services/device-detector.service';


@Component({
  selector: 'app-resigtering',
  templateUrl: './resigtering.component.html',
  styleUrl: './resigtering.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class ResigteringComponent implements OnInit {
  data!: FormGroup;
  contentReady: boolean = false;
  userInfo: any;
  @ViewChild('fileInput', { static: false }) fileInput!: ElementRef;
  imageSrc: string | ArrayBuffer | null = null;
  selectedFile: File | null = null;
  mediaFiles!: File;
  media!: any;
  isMobile: boolean = false;
  isAr: boolean = false;
  defaultImage: string = '/assets/card photo.png';
  type!: any;
  formInfo = new FormGroup({
    name: new FormControl(''),
    sname: new FormControl(''),
    username: new FormControl(''),
    instagram: new FormControl(''),
    facebook: new FormControl(''),
    tiktok: new FormControl(''),
    phone: new FormControl(''),
    type: new FormControl("0"),
    password: new FormControl(''),
    c_Password: new FormControl(''),
    media: new FormControl(''),
    has_access_to_phone_numbers: new FormControl<string | null>(null, Validators.required),
    access_pages: new FormControl<number[]>([]),
  });
  registerRequest: IRegisterInterface = {} as IRegisterInterface;
  errorExit: boolean = false;
  newUserEmail: string = '';
  accounttype: string = '';
  isUpdatePage: boolean = false;
  editedUserId!: any;
  first_name!: any;
  username!: any;
  last_name!: any;
  instagram_link!: any;
  facebook_link!: any;
  tiktok_link!: any;
  phone!: any;
  image!: any;
  read_password!: any;
  hasAccessPN!: any;
  isAdmin$: Observable<boolean> = this._userService.getAccountType().pipe(
    map(data => this.accounttype === '1')
  );
  accessPagesList = [
    { value: 0, label: 'الموظفين' },
    { value: 1, label: 'المحاسب' },
    { value: 2, label: 'عملائي' },
    { value: 3, label: 'طلبيات' },
    { value: 4, label: 'الطيران' },
    { value: 5, label: 'داتافلو' },
    { value: 6, label: 'الكوادر' },
    { value: 7, label: 'الاطباء' },
    { value: 8, label: 'الشركات' },

  ];
  accessPages: number[] = [];
  constructor(
    private _formBuilder: FormBuilder,
    private _ResigteringService: ResigteringService,
    private _Router: Router,
    private deviceService: DeviceDetectorService,
    private _LoginService: LoginService,
    private route: ActivatedRoute,
    private _userService: UserService
  ) { }

  validateAreEqual(pass: string, c_Pass: string) {
    return (group: FormGroup) => {
      const password = group.controls[pass];
      const c_Password = group.controls[c_Pass];
      if (password.value !== c_Password.value) {
        c_Password.setErrors({ passwordMismatch: true });
      } else {
        c_Password.setErrors(null);
      }
    };
  }

  ngOnInit(): void {
    this.isMobile = this.deviceService.isMobileDevice();
    this.isAr = localStorage.getItem("language") == "ar";
    this.route.queryParams.subscribe(params => {
      if (params["id"] != null)
        this.isUpdatePage = true;


      this.editedUserId = params["id"];
      this.first_name = params["first_name"];
      this.username = params["username"];
      this.last_name = params["last_name"];
      this.instagram_link = params["instagram_link"];
      this.facebook_link = params["facebook_link"];
      this.tiktok_link = params["tiktok_link"];
      this.phone = params["phone"];
      this.image = params["image"];
      this.read_password = params["read_password"];
      this.type = params["type"];
      this.hasAccessPN = params["has_access_to_phone_numbers"] === "1" || params["has_access_to_phone_numbers"] === true ? "1" : "0";
      this.accessPages = params['access_pages']
        ? Array.isArray(params['access_pages'])
          ? params['access_pages'].map(Number)
          : JSON.parse(params['access_pages'])
        : [];
      console.log(this.image)
    });

    this.checkAccountType();

    this.formInfo = this._formBuilder.group(
      {
        name: [
          '',
          [
            Validators.required,
            Validators.minLength(3),
            Validators.maxLength(60),

            Validators.pattern('[a-zA-Z\u0600-\u06FF ]*')
          ],
        ],

        sname: [
          '',
          [
            Validators.required,
            Validators.minLength(3),
            Validators.maxLength(60),

            Validators.pattern('[a-zA-Z\u0600-\u06FF ]*')
          ],
        ],

        facebook: [''],
        instagram: [''],
        tiktok: [''],
        media: [Validators.required],
        username: ['', [Validators.required]],
        phone: [
          '',
          [
            Validators.required,
            Validators.pattern(`^\\d{11}$`),
            Validators.minLength(11),
            Validators.maxLength(11),

          ],
        ],
        type: ['', [Validators.required]],
        has_access_to_phone_numbers: ['', [Validators.required]],
        password: [
          '',
          [
            Validators.required,
            Validators.maxLength(40),
            Validators.minLength(8),
            // Validators.pattern(
            //   '^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$'
            // ),
          ],
        ],
        c_Password: ['', [Validators.required]]
      },
      { validator: this.validateAreEqual('password', 'c_Password') }
    );

    if (this.isUpdatePage) {
      this.formInfo.patchValue({
        name: this.first_name,
        sname: this.last_name,
        username: this.username,
        instagram: this.instagram_link,
        facebook: this.facebook_link,
        tiktok: this.tiktok_link,
        phone: this.phone,
        type: this.type ? this.type.toString() : '',
        has_access_to_phone_numbers: this.hasAccessPN,
        access_pages: this.accessPages
      });

    }
  }
  // ✅ التغيير لما المستخدم يضغط
  onCheckboxChange(event: any) {
    const value = +event.target.value; // convert string → number

    if (event.target.checked) {
      // أضف لو مش موجود
      if (!this.accessPages.includes(value)) {
        this.accessPages.push(value);
      }
    } else {
      // شيل لو متشال
      this.accessPages = this.accessPages.filter(v => v !== value);
    }
  }

  fixImgUrl(url: any) {
    return "https://backendtest.blueboxpet.com/" + url
  }
  triggerFileInput() {
    this.fileInput.nativeElement.click();
  }
  checkAccountType() {
    this._userService.getAccountType().subscribe({
      next: (data) => {

        this.accounttype = data['user_type'];


      },
      error: (error) => console.error(error),
    });
    return this.accounttype;
  }
  onFileChange(event: any) {

    const file = event.target.files[0];
    if (file) {
      this.mediaFiles = file;
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.media = e.target.result;
      };
      const url: string = URL.createObjectURL(file);

      reader.readAsDataURL(file);

    }
    console.log(this.mediaFiles)
  }
  saveEmail(e: string) {
    sessionStorage.setItem('email', e);
  }
  password: string = '';
  isPasswordVisible: boolean = false;
  togglePasswordVisibility() {
    this.isPasswordVisible = !this.isPasswordVisible;
  }
  onSubmit() {
    this.contentReady = true;




    if (!this.formInfo.valid) {

      this.contentReady = false;
      return;
    }

    const selectedGender = this.formInfo.value.type;
    const fv = this.formInfo.value;

    // Create a new FormData object
    const formData = new FormData();

    // Append form fields to the FormData object
    formData.append('first_name', fv.name?.toString() ?? '');
    formData.append('last_name', fv.sname?.toString() ?? '');
    formData.append('instagram_link', fv.instagram?.toString() ?? '');
    formData.append('facebook_link', fv.facebook?.toString() ?? '');
    formData.append('tiktok_link', fv.tiktok?.toString() ?? '');
    formData.append('username', fv.username?.toString() ?? '');
    formData.append('password', fv.password?.toString() ?? '');
    formData.append('password_confirmation', fv.c_Password?.toString() ?? '');
    formData.append('phone', fv.phone?.toString() ?? '');
    formData.append(
      'has_access_to_phone_numbers',
      this.formInfo.value.has_access_to_phone_numbers ?? '0'
    );
    formData.append('type', selectedGender?.toString() ?? '');
        this.accessPages.forEach((page: number, index: number) => {
      formData.append(`access_pages[${index}]`, page.toString());
    });
    // If there's an image file, append it to FormData
    if (this.mediaFiles) {
      formData.append('image', this.mediaFiles, this.mediaFiles.name); // Add image file to FormData
    }

    if (this.isUpdatePage) {
      this._ResigteringService.editUser(this.editedUserId, formData).subscribe({
        next: (res) => {
          this.contentReady = false;
          Swal.fire({
            icon: 'success',
            title: this.isAr ? "تم تعديل الحساب" : 'user updated successfully',
            showConfirmButton: false,
            timer: 1500,
          });

          const fv = this.formInfo.value!;

          if (this.isMobile)
            this._Router.navigate(['/allusers.mobile']);
          else
            this._Router.navigate(['/allusers']);
        },
        error: (err) => {
          this.contentReady = false;

          Swal.fire({
            icon: 'error',
            title: this.isAr ? "  حصل مشكلة في انشاء المستخدم " : 'error while adding this user',
            text: this.isAr ? 'كلم الدعم' : 'you have to contact us',
            confirmButtonText: this.isAr ? 'تمام' : 'ok',
          });
          this.errorExit = true;
        },
      });
    }
    else {

      // Send the form data to the service
      this._ResigteringService.user_Resigter(formData).subscribe({
        next: (res) => {
          this.contentReady = false;
          Swal.fire({
            icon: 'success',
            title: this.isAr ? "تم انشاء الحساب" : 'user added successfully',
            showConfirmButton: false,
            timer: 1500,
          });

          const fv = this.formInfo.value!;

          if (this.isMobile)
            this._Router.navigate(['/allusers.mobile']);
          else
            this._Router.navigate(['/allusers']);
        },
        error: (err) => {
          this.contentReady = false;

          Swal.fire({
            icon: 'error',
            title: this.isAr ? "  حصل مشكلة في انشاء المستخدم " : 'error while adding this user',
            text: this.isAr ? 'كلم الدعم' : 'you have to contact us',
            confirmButtonText: this.isAr ? 'تمام' : 'ok',
          });
          this.errorExit = true;
        },
      });
    }
  }
  private decodeToken(token: string) {
    return JSON.parse(atob(token.split('.')[1]));
  }

}
